module.exports = __webpack_public_path__ + "static/img/fefco202_2.362cbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco202_2.png
// module id = PzXI
// module chunks = 0